<button (click)="remove()" type="button" class="guide-toast-close-btn" aria-label="Close">
  <icon [name]="'x-close'" [size]="5" [currentColor]="'white'"></icon>
</button>
<div class="guide-toast-icon-box">
  <icon name="check-success" [size]="5" [currentColor]="'dt-custom-teal-11'"></icon>
</div>
<div class="guide-toast-text">
  @if (title) {
    <div class="guide-toast-title">{{ title }}</div>
  }
  @if (message) {
    <div class="guide-toast-body">{{ message }}</div>
  }
</div>
